jQuery(function() {
    jQuery(".js-load-more-press__button").on("click", function(e) {
        e.preventDefault();
        jQuery( this ).prop( "disabled", true );
        //console.log("get data");
        //var cat = jQuery(".js-load-more-press__button").attr('data-cat');
        var paged = jQuery(".js-load-more-press__button").attr('data-paged');
        var max_paged = jQuery(".js-load-more-press__button").attr('data-maxpages');
        $.ajax({
            //url: "http://freeway.test/api/knowledge/get-paged-posts.php",
            url: window.location.origin + "/api/press/get-paged-posts.php",
            data: "paged=" + paged,
            type: "GET",
            //dataType: "jsonp", 
            success: function(data) {
                if (data.length > 0) {
                    paged = parseInt(paged) + 1;
                    if (paged > max_paged) {
                        jQuery(".js-load-more-press__button").hide();
                    }
                    jQuery(".js-load-more-press__button").attr('data-paged', paged);
                    jQuery(".c-press-content .c-press-content__item:last").after(data);
                    jQuery(".js-load-more-press__button").prop( "disabled", false );
                } 
                //console.log(data);
                //console.log("get data");

            }
        });
    })
})